var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFmsWorkflow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "habvs4io2a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 15414",
    transform: "translate(1214 2738)",
    style: {
      fill: "#ff2e2e",
      opacity: 0.158
    },
    d: "M0 0h180v180H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "workflow_icon",
    transform: "translate(-1214 -2738)",
    style: {
      clipPath: "url(#habvs4io2a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 707",
    transform: "translate(256.126 449)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59683",
    d: "M112.178 92.043a20.135 20.135 0 1 1-20.134-20.134 20.134 20.134 0 0 1 20.134 20.134z",
    transform: "translate(1000.696 2331.822)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 105",
    cx: 7.288,
    cy: 7.288,
    r: 7.288,
    transform: "translate(1085.451 2322.997)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 106",
    cx: 7.288,
    cy: 7.288,
    r: 7.288,
    transform: "translate(991.871 2416.577)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 107",
    cx: 11.028,
    cy: 11.028,
    r: 11.028,
    transform: "translate(999.159 2330.285)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 115",
    transform: "translate(999.16 2360.5)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 56.077V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 116",
    transform: "translate(1006.447 2423.866)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M66.157 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 117",
    transform: "translate(1092.739 2337.574)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0v66.157"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 118",
    transform: "translate(1028.375 2330.285)",
    style: {
      stroke: "#fff",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    },
    d: "M0 0h57.077"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 108",
    cx: 7.288,
    cy: 7.288,
    r: 7.288,
    transform: "translate(1085.451 2416.577)",
    style: {
      stroke: "#4cbbb8",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 59684",
    d: "M55.627 32.485v-8.343a.958.958 0 0 0-.958-.958h-5.883a.957.957 0 0 1-.914-.695 20.322 20.322 0 0 0-1.61-3.89.955.955 0 0 1 .156-1.136l4.158-4.158a.958.958 0 0 0 0-1.355l-5.9-5.9a.956.956 0 0 0-1.354 0l-4.16 4.16a.955.955 0 0 1-1.136.154 20.311 20.311 0 0 0-3.889-1.61.955.955 0 0 1-.695-.912V1.958A.958.958 0 0 0 32.485 1h-8.344a.958.958 0 0 0-.958.958v5.884a.955.955 0 0 1-.695.912 20.311 20.311 0 0 0-3.889 1.61.955.955 0 0 1-1.136-.154L13.3 6.05a.956.956 0 0 0-1.354 0l-5.9 5.9a.958.958 0 0 0 0 1.355l4.158 4.158a.955.955 0 0 1 .156 1.136 20.322 20.322 0 0 0-1.61 3.89.957.957 0 0 1-.914.695H1.958a.958.958 0 0 0-.958.958v8.343a.958.958 0 0 0 .958.958h5.883a.957.957 0 0 1 .914.695 20.311 20.311 0 0 0 1.61 3.889.955.955 0 0 1-.156 1.136l-4.159 4.16a.956.956 0 0 0 0 1.354l5.9 5.9a.959.959 0 0 0 1.354 0l4.16-4.16a.957.957 0 0 1 1.136-.156 20.15 20.15 0 0 0 3.889 1.61.957.957 0 0 1 .695.914v5.883a.958.958 0 0 0 .958.958h8.344a.958.958 0 0 0 .958-.958v-5.882a.957.957 0 0 1 .695-.914 20.15 20.15 0 0 0 3.889-1.61.957.957 0 0 1 1.136.156l4.16 4.16a.959.959 0 0 0 1.354 0l5.9-5.9a.956.956 0 0 0 0-1.354l-4.158-4.16a.955.955 0 0 1-.156-1.136 20.311 20.311 0 0 0 1.61-3.889.957.957 0 0 1 .914-.695h5.883a.958.958 0 0 0 .956-.959z",
    transform: "translate(981.874 2313)",
    style: {
      stroke: "#4cbbb8",
      fill: "none",
      strokeLinecap: "round",
      strokeWidth: 2
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFmsWorkflow);
export default __webpack_public_path__ + "static/media/ico_fms_workflow.d29081d8b6c3afaf842211921331d0f0.svg";
export { ForwardRef as ReactComponent };